/**
 * Formats a number or string as a currency string with the Turkish Lira symbol.
 * Example: 1250000 -> ₺1.250.000
 * 
 * @param {number|string} amount - The numeric value to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || amount === '') return '0 ₺';
  
  let numericValue = typeof amount === 'string' 
    ? parseFloat(amount.replace(/[^0-9]/g, '')) 
    : amount;

  if (isNaN(numericValue)) return '0 ₺';

  return numericValue.toLocaleString('tr-TR') + ' ₺';
};

/**
 * Formats mileage with thousands separator and "KM" suffix.
 * Example: 125000 -> 125.000 KM
 */
export const formatMileage = (mileage) => {
  if (!mileage) return '0 KM';
  const val = typeof mileage === 'string' ? parseInt(mileage.replace(/[^0-9]/g, '')) : mileage;
  if (isNaN(val)) return '0 KM';
  return `${val.toLocaleString('tr-TR')} KM`;
};
